/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .controller('NotarizedFilesController', ['$scope', 'headerService', 'NotarizedFileRevision', '$translate',
        function($scope, headerService, NotarizedFileRevision, $translate) {
            $translate('node_notarization_notarized_files_section_title').then(function(translation) {
                headerService.addBreadcrumbsRootItem(translation, null);
            });

            $scope.table = {
                model: NotarizedFileRevision,
                perPage: 100
            };
        }]);
